import Content from "uxp-documentation/src/pages/uxp/reference-js/Modules/uxp/Persistent File Storage/modes";
import * as React from 'react';
export default {
  Content,
  React
};